var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { USER_ROLES } from "@constants/Roles";
import { createFilterOptions } from "@mui/material";
import { PeekAutocomplete, PeekInput, PeekListItem } from "@piiqtechnologies/ui-components";
import { useDebounce, useError, useUsers } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useMemo, useState } from "react";
const filter = createFilterOptions();
export function ScannerEmailSelector(_a) {
    var { disabled = false, form, field } = _a, props = __rest(_a, ["disabled", "form", "field"]);
    const { setError } = useError();
    const [searchKey, setSearchKey] = useState();
    const debouncedSearchKey = useDebounce(searchKey, 700);
    const [getUsers, users, usersLoading, usersError] = useUsers();
    useEffect(() => {
        getUsers({
            limit: 100,
            roleId: USER_ROLES.Scanner,
            search: debouncedSearchKey,
        });
    }, [debouncedSearchKey]);
    const usersOptions = useMemo(() => {
        var _a;
        return (_a = users === null || users === void 0 ? void 0 : users.data) === null || _a === void 0 ? void 0 : _a.filter(({ name, email }) => !debouncedSearchKey ||
            name.match(new RegExp(debouncedSearchKey, "i")) ||
            email.match(new RegExp(debouncedSearchKey, "i"))).map(({ email, name }) => ({ email: email, title: `${name} - ${email}` }));
    }, [users === null || users === void 0 ? void 0 : users.data, debouncedSearchKey]);
    useEffect(() => {
        if (usersError)
            setError(usersError === null || usersError === void 0 ? void 0 : usersError.message);
    }, [usersError]);
    const userSelection = (_event, item) => {
        //@ts-ignore
        form.setFieldValue(field.name, item === null || item === void 0 ? void 0 : item.email);
    };
    return (React.createElement(PeekAutocomplete, { freeSolo: false, popupIcon: null, loading: usersLoading, defaultValue: { email: (field === null || field === void 0 ? void 0 : field.value) || "" }, disabled: disabled, onChange: userSelection, options: usersOptions || [], sx: { ".MuiAutocomplete-input": { pl: "13px !important" } }, getOptionLabel: (option) => option.email, renderOption: (optionsProps, option) => React.createElement(PeekListItem, Object.assign({}, optionsProps), option.title), filterOptions: (options, params) => {
            const filtered = filter(options, params);
            const { inputValue } = params;
            const isExisting = options.some((option) => inputValue === option.email);
            if (inputValue !== "" && !isExisting) {
                filtered.push({
                    title: `Add "${inputValue}"`,
                    email: inputValue,
                });
            }
            return filtered;
        }, renderInput: (params) => {
            return (React.createElement(PeekInput, Object.assign({ defaultValue: (field === null || field === void 0 ? void 0 : field.value) || "", field: Object.assign(Object.assign({}, field), { value: searchKey, onChange: (e) => setSearchKey(e.target.value) }), form: form }, params, props)));
        } }));
}
